import { Loader } from '@components/loader';
import { TdsMerchantPage } from '@pages/tdsMerchants/id';
import { useGetTdsMerchant } from '@services/staff/tdsMerchants/get';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

function StaffTdsMerchant() {
  const navigate = useNavigate();
  const { localId, id } = useParams({ from: '/u/$localId/_staff/staff/tds-merchants/$id' });
  const { data, isPending } = useGetTdsMerchant({ id });

  if (isPending) return <Loader />;
  if (!data) return null;

  return (
    <TdsMerchantPage
      tdsMerchant={data}
      onLinkedMerchantSelect={(merchantId) => {
        navigate({
          to: '/u/$localId/staff/merchants/$merchantId/orders',
          params: { merchantId, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/tds-merchants/$id')({
  component: StaffTdsMerchant,
});
